import { useStores } from "../../core/stores/rootStore";
import React, { useContext, useEffect, useState,useRef} from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react";
import { useTranslation, Trans } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Button from 'react-bootstrap/Button';
import Stack from 'react-bootstrap/Stack';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Pagination from 'react-bootstrap/Pagination';
import Skeleton from 'react-loading-skeleton'
import ConfirmPopup from './../modal/modal';
import ManagementTable from "./../tables/managementTable";
import { boolToYesNo, getUnits, stripHTML, setConfig, getConfig, getYesNo} from "../../utils"
import cloneDeep from 'lodash/cloneDeep';


const CountryCurrenciesAdmin = () => {

    let navigate = useNavigate();
    const { usersAdminStore, loginStore, templatesStore, utilsStore, countryCurrencyStore }= useStores();
    //const { getAllUsers, users, templates, getAll, remove, duplicate } = templatesStore;
    //const { currencies, getCurrencies } = utilsStore;
    const { getAll, countryCurrencies, remove, duplicate, getAllWithOptions,/* setConfig, config*/ } = countryCurrencyStore;
    const { t, i18n } = useTranslation();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [isLoading, setIsLoading] = useState(false);
    const tableRef = useRef(null);

    /*useEffect(() => {
        setIsLoading(true);
        async function fetchMyAPI() {
            getAll().then(() => {
                setIsLoading(false);
            });
        }

        fetchMyAPI();
    }, [getAll]);*/
    /**useEffect(() => {
        alert(templates?.results?.length?.toString())
    }, [templates?.results])*/

    const onPageChange = (props) => {        
        var newProps = cloneDeep(props);

        newProps.filterBy?.filters?.forEach(main => {
            main?.filters?.forEach(f => {
                /*if (["workUnit", "billingUnit", "salaryUnit"].indexOf(f.field) > -1) {
                    f.value = getUnitOptions()?.find(x => x.text == f.value)?.value;
                }*/

            });
        });
        setIsLoading(true);
        getAllWithOptions(newProps/*props.page + 1, props.filter, props.sort*/).then(() => {
            setIsLoading(false);
        });
    }

    return (
        <ManagementTable name={t('countryCurrencies')} ref={tableRef} isLoading={isLoading}
            config={{
                size: getConfig("countryCurrencies", "size"),
                dataState: getConfig("countryCurrencies", "dataState")
            }}
            onColumnSizeChange={(c) => setConfig("countryCurrencies", "size", c)}
            onDataStateChange={(c) => { setConfig("countryCurrencies", "dataState", c) }}

            //filters={["name","shortName","symbol"]}
            /*onDelete={(id) => {
                remove(id).then(() => { tableRef?.current?.resetPage() })
            }}*/
            /*onEdit={(id) => {
                alert(id)
            }}*/
            items={countryCurrencies?.results} onPageChange={onPageChange} pageCount={countryCurrencies?.pageCount} total={countryCurrencies?.count} pageSize={countryCurrencies?.pageSize} columns={
                [
                    { name: "countryEN" },
                    { name: "countryFR" },
                    { name: "code", fn:(v)=>v?.toUpperCase() }
                    //{ name: "symbol" },
                ]}
            extraButtons={
                [
                    { text: t('edit'), icon: solid("pen-to-square"), onClick: (id) => { navigate(`./${id}`) } },
                    //{ text: t('copy'), icon: solid("copy"), onClick: (id) => { duplicate(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmCopy"), modalTitle: t("copy") },
                    { text: t('delete'), icon: solid("trash"), onClick: (id) => { remove(id).then(() => { tableRef?.current?.resetPage() }) }, modalText: t("confirmDelete"), modalTitle: t("delete"), danger: true }
                ]
            }
             />

    );

   
};

export default observer(CountryCurrenciesAdmin);
